import {
  TrackingClient,
  TrackingCustomerData,
  trackCustomerData,
} from '@aboutyou/legacy-tracking-sdk';

let hasFired = false;

export const resetCustomerDataOnceGuard = () => {
  hasFired = false;
};

export const trackCustomerDataOnce = (
  client: TrackingClient,
  customer: TrackingCustomerData,
) => {
  if (hasFired) {
    return;
  }
  hasFired = true;
  client.track(trackCustomerData({customer}));
};
